module.exports = __webpack_public_path__ + "img/logo_4pda.13870d40.png";